import { Reducer } from "redux";

import { IcdCodeTypeActionDispatchTypes } from "../constants/ICD10";
import { IcdCodeTypeDispatchTypes } from "../models/dispatchTypes/ICD10";
import { IcdCodeTypeResponse } from "../models/api/ICD10";

const initialState: IcdCodeTypeResponse = {
  loading: false,
  response: [
    {
      diagnosisTypeId: 0,
      diagnosisType: "",
    },
  ],
};

const IcdCodeTypeReducer: Reducer<
  IcdCodeTypeResponse,
  IcdCodeTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case IcdCodeTypeActionDispatchTypes.ICD_CODE_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case IcdCodeTypeActionDispatchTypes.ICD_CODE_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default IcdCodeTypeReducer;
